import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Row, Col, OverlayTrigger, Tooltip,
} from 'react-bootstrap5';

import routes from 'app/routes';
import IconWithText from 'components/Widgets/IconWithText';
import CoachIcon from 'components/Common/Coaches/Widgets/Icon/Index';

import AvatarIcon from 'components/Members/Programs/Widgets/Info/AvatarIcon';

import ProgramTeaserAi from './ProgramTeaserAi';

export default function ProgramInfo({ program }) {
  const renderTooltip = (props) => (
    <Tooltip {...props}>
      Chat with your Coach
    </Tooltip>
  );

  return (
    <Row className="mb-5">

      {program.attributes.program_category === 'ai' ? (
        <ProgramTeaserAi program={program} />
      ) : (
        <>
          <Col xs={6} md={4} lg={3} xl={2}>
            <div className="mb-1 small text-gray-700 fw-light">Live Sessions</div>

            <div className="fw-semibold">
              {program.attributes.count_sessions}
            &nbsp;(Every 2 weeks)
            </div>
          </Col>

          <Col xs={6} md={4} lg={2} xl={1}>
            <div className="mb-1 small text-gray-700 fw-light">Cost</div>

            <div className="fw-semibold">
              {program.attributes.count_sessions}
            &nbsp;credits
            </div>
          </Col>
        </>
      )}

      <Col lg={1} className="d-none d-lg-block">
        <div
          className="h-100 mx-auto border-start"
          style={{ width: '1px' }}
        />
      </Col>

      <Col
        md={12}
        lg={program.attributes.program_category === 'ai' ? 5 : 6}
        xl={program.attributes.program_category === 'ai' ? 7 : 8}
        className="d-flex align-items-center mt-3 mt-lg-0"
      >
        {program.attributes.coach && (
        <CoachIcon
          coach={program.attributes.coach}
          link={routes.coaches.show(program.attributes.coach.id)}
          bigIcon={false}
        />
        )}

        {program.attributes.program_category === 'ai' && (
        <AvatarIcon
          avatar={program.attributes.avatar}
          bigIcon={false}
        />
        )}

        {program.attributes.chat_id && (
          <OverlayTrigger overlay={renderTooltip}>
            <a
              href={routes.members.chats.messages(program.attributes.chat_id)}
              className="btn btn-light btn-sm ms-2 ms-md-3"
            >
              <IconWithText
                iconClassName="navigation-chat-icon"
                iconStyle={{ minHeight: '21px', minWidth: '21px' }}
              />
            </a>
          </OverlayTrigger>
        )}

        {(program.attributes.possible_send_change_coach_request
          && program.attributes.program_category === 'coaching') && (
          <Link
            to={routes.members.programs.program.changeCoach}
            className="btn btn-light btn-sm ms-2 ms-md-3"
          >
            Change Coach
          </Link>
        )}
      </Col>
    </Row>
  );
}

ProgramInfo.propTypes = {
  program: PropTypes.object.isRequired,
};
